import React, { PureComponent } from 'react';
import ResponsiveImage from '../responsiveImage';
import SearchWidget from '../search/search-widget'; 
import { connect } from 'react-redux';
import ItineraryWidget from './itineraryWidget';
import ConfirmationWidget from './confirmationWiget';
const queryString = require('query-string');

class Masthead extends PureComponent { 

  render(){

    const { isApBus, isItinerary, isConfirmation, currentBooking:{tmsBookingId, agent, agency}, isShare } = this.props;

    const mastheadObj = {
      image : !this.props.image ? "//images.ctfassets.net/3ng3kfj0qs70/27qmPhp8eIMyCYSwk6iY2W/ff34138c00c39b8998ca1277d0a27aa7/6.jpg" : this.props.image 
    }

    const hasShare = queryString.parse(window.location.search).ap === "share" ? true : false;

    let _agentName, _agency;
    try{
       _agentName = !hasShare ? "": agent;
       _agency = !hasShare ? "": agency;
    }
    catch(e){}
  
    return (
      <div className="header header-bg">
    
       <div className="masthead-img">

            <ResponsiveImage 
                  quality={70}
                  src={mastheadObj.image}
                  width={1600}
                  widthRetina={1920}
                  alt={"Masthead"}
              />

        </div>

        { hasShare && 
          <div className="nav-container">
          <div className="max-width-5 mx-auto header-nobg">
              <div className="clearfix row">
                <div className="col col-12">
                    <div className="col col-5 sm-col-6 md-col-2 px2">
                        <a className="logo no-pointer-event" title="Busabout">
                            <img src="https://images.ctfassets.net/9uj5p2yo1ox0/5YR77rJ0oED1UTZMBnc9V4/840eef994f984d7852e82e49655e7b46/ba-logo.svg" width="150" height="32" alt="Busabout" />
                        </a>
                    </div>
                    <div className="col col-7 sm-col-6 md-col-4 px2 col-right">
                
                            <ul className="user-login light">
                              <li>
                                  <a className={`user-login-name no-pointer-event'}`}>
                             
                                      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" className="mr1 inline-block">
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M1.606 5.394a5.394 5.394 0 1 0 10.788 0 5.394 5.394 0 0 0-10.788 0L2.8 4.552a4.293 4.293 0 1 1 8.423 1.659A4.293 4.293 0 0 1 2.8 4.552l-1.194.842z"/>
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M6.973 8.648c-1.187-.001-2.24-.814-2.613-2.018a.614.614 0 0 1 .097-.587.525.525 0 0 1 .528-.189c.195.045.352.2.408.406.232.758.91 1.258 1.655 1.221.746-.036 1.378-.6 1.545-1.378a.574.574 0 0 1 .366-.472.52.52 0 0 1 .559.14.611.611 0 0 1 .131.598c-.297 1.326-1.4 2.266-2.676 2.279z"/>
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M.003 15.291c.054.25.273.428.528.43h12.938a.545.545 0 0 0 .528-.429 4.006 4.006 0 0 0-1.082-2.887A7.326 7.326 0 0 0 7 9.782a7.326 7.326 0 0 0-5.914 2.623 4.006 4.006 0 0 0-1.083 2.886l12.888-.659H1.11a4.233 4.233 0 0 1 .824-1.543A6.255 6.255 0 0 1 7 10.872a6.257 6.257 0 0 1 5.067 2.217c.38.451.66.977.824 1.543l-12.888.66z"/>
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M1.606 5.394a5.394 5.394 0 1 0 10.788 0 5.394 5.394 0 0 0-10.788 0L2.8 4.552a4.293 4.293 0 1 1 8.423 1.659A4.293 4.293 0 0 1 2.8 4.552l-1.194.842z"/>
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M6.973 8.648c-1.187-.001-2.24-.814-2.613-2.018a.614.614 0 0 1 .097-.587.525.525 0 0 1 .528-.189c.195.045.352.2.408.406.232.758.91 1.258 1.655 1.221.746-.036 1.378-.6 1.545-1.378a.574.574 0 0 1 .366-.472.52.52 0 0 1 .559.14.611.611 0 0 1 .131.598c-.297 1.326-1.4 2.266-2.676 2.279z"/>
                                        <path fill="#3D3D3D" fillRule="evenodd" d="M.003 15.291c.054.25.273.428.528.43h12.938a.545.545 0 0 0 .528-.429 4.006 4.006 0 0 0-1.082-2.887A7.326 7.326 0 0 0 7 9.782a7.326 7.326 0 0 0-5.914 2.623 4.006 4.006 0 0 0-1.083 2.886l12.888-.659H1.11a4.233 4.233 0 0 1 .824-1.543A6.255 6.255 0 0 1 7 10.872a6.257 6.257 0 0 1 5.067 2.217c.38.451.66.977.824 1.543l-12.888.66z"/>
                                      </svg>
                                  

                                    <span className="bold">
                                      {_agentName}
                                    </span>
                                  </a>
                              </li>
                              <li>
                                  <p className="agent-text">{_agency}</p>
                              </li>
                          </ul>
                      </div>
                </div>  
              </div>  
          </div> 
        </div> 
        }
        { isApBus && <SearchWidget isAdventurePlanner={true} isApBus={true}/> }                               
        { isItinerary && <ItineraryWidget isShare={isShare} /> }
        { isConfirmation && <ConfirmationWidget tmsBookingId={tmsBookingId}/> }
        
       <div className="paint-stroke initial">
   
            <img
                className="lazyload"
                data-src="https://images.contentful.com/3ng3kfj0qs70/58izAOMgU0qsuIey6U60Ig/b41aa16ee51e6d31f2926d43f8582832/paintstroke.svg"
                alt=""/>
      
        </div>
  
        </div>
    )
  }
}

const mapStateToProps = state => {
  return{
    currentBooking:state.currentBooking
  }
}

export default connect(mapStateToProps, null)(Masthead); 

